module.exports = __webpack_public_path__ + "officialStatic/img/gxkjLogo.d02bef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/gxkjLogo.png
// module id = EVSM
// module chunks = 0